var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adaptive-image",style:([{maxWidth: `${_vm.maxWidth}px`}, {maxHeight: `${_vm.maxHeight}px`}]),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"img-inner"},[(_vm.url)?_c('img',{ref:"img",staticClass:"img",attrs:{"src":_vm.url,"alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }